module.exports = __webpack_public_path__ + "img/Z60_18.22405dac.jpg";